import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { videos } from "@/mocks/videos";
import Breadcrumb from "@/components/feature/Breadcrumb";
import usePageMeta from "@/hooks/usePageMeta";
import { formatCount } from "@/utils/format";
import FeedbackForm from "./components/FeedbackForm";

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 吃瓜视频",
    description:
      "了解吃瓜视频的品牌背景、内容范围与定位，并获取联系方式与合作反馈渠道。吃瓜视频专注娱乐视频资讯与热点内容。",
    keywords: "关于吃瓜视频,吃瓜视频介绍,联系我们,娱乐视频资讯",
  });

  const totalViews = videos.reduce((acc, v) => acc + v.views, 0);

  const values = [
    {
      icon: "ri-flashlight-line",
      title: "更快一步",
      desc: "紧跟娱乐与社会热点节奏，第一时间呈现值得关注的内容。",
    },
    {
      icon: "ri-layout-grid-line",
      title: "清晰分类",
      desc: "按兴趣组织内容，让浏览更高效、更好找。",
    },
    {
      icon: "ri-shield-check-line",
      title: "真实可靠",
      desc: "内容标注来源，尊重事实，拒绝夸大与标题党。",
    },
  ];

  return (
    <div className="w-full">
      <div className="border-b border-background-200 bg-primary-50">
        <div className="w-full px-4 py-8 md:px-8 md:py-12">
          <Breadcrumb items={[{ label: "首页", href: "/" }, { label: "关于我们" }]} />
          <h1 className="mt-5 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
            关于吃瓜视频
          </h1>
          <p className="mt-4 max-w-3xl text-sm leading-7 text-foreground-700 md:text-base">
            吃瓜视频是一个聚焦娱乐资讯与热点内容的视频门户。我们用更快的信息节奏、更清晰的分类浏览和更舒适的观看体验，
            陪伴每一位关注娱乐、关注生活的你，不错过那些真正值得一聊的话题。
          </p>
        </div>
      </div>

      <div className="w-full px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="font-heading text-2xl font-black text-primary-500 md:text-3xl">{videos.length}</p>
            <p className="mt-1 text-sm text-foreground-600">在库视频</p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="font-heading text-2xl font-black text-accent-600 md:text-3xl">{categories.length}</p>
            <p className="mt-1 text-sm text-foreground-600">内容分类</p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="font-heading text-2xl font-black text-primary-500 md:text-3xl">{formatCount(totalViews)}</p>
            <p className="mt-1 text-sm text-foreground-600">累计播放</p>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <p className="font-heading text-2xl font-black text-accent-600 md:text-3xl">7×24</p>
            <p className="mt-1 text-sm text-foreground-600">持续更新</p>
          </div>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">我们的定位</h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700 md:text-base">
              吃瓜视频面向关注娱乐新闻与短视频内容的广泛网民，尤其服务于习惯用手机快速浏览信息的人群。
              内容范围覆盖明星动态、社会热点、趣味短片、影视资讯、音乐现场与游戏电竞等多个方向。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-700 md:text-base">
              我们不追逐低俗炒作，而是希望在轻松与真实之间找到平衡：既能满足你对热点的即时关注，
              也能让你在忙碌之余，获得片刻的轻松与共鸣。
            </p>

            <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {values.map((item) => (
                <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-600">
                    <i className={item.icon} />
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-900">{item.title}</h3>
                  <p className="mt-1 text-xs leading-5 text-foreground-600">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-5">
              <h3 className="font-heading text-base font-bold text-foreground-950">联系方式</h3>
              <ul className="mt-3 space-y-2.5 text-sm text-foreground-700">
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-mail-line text-base" />
                  </span>
                  hello@chiguatv.com
                </li>
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-phone-line text-base" />
                  </span>
                  400-000-8888（工作日 9:00 - 18:00）
                </li>
                <li className="flex items-center gap-2">
                  <span className="flex h-4 w-4 items-center justify-center text-primary-500">
                    <i className="ri-map-pin-line text-base" />
                  </span>
                  上海市静安区创意园区 A 座 12 层
                </li>
              </ul>
            </div>
          </div>

          <div>
            <FeedbackForm />
          </div>
        </div>

        <div className="mt-12 rounded-lg border border-background-200 bg-background-50 p-5 md:p-7">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">版权及隐私声明</h2>
          <div className="mt-4 grid grid-cols-1 gap-6 md:grid-cols-2">
            <div>
              <h3 className="text-sm font-bold text-foreground-900">版权说明</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-700">
                本站展示的视频与图文内容均为演示用途，版权归原作者或相应权利人所有。如涉及作品内容、版权或其它问题，
                请通过上方反馈表单与我们联系，我们会尽快处理。
              </p>
            </div>
            <div>
              <h3 className="text-sm font-bold text-foreground-900">隐私声明</h3>
              <p className="mt-2 text-sm leading-7 text-foreground-700">
                我们仅在为你提供反馈回复时使用你主动提交的联系方式，不会用于其它用途，也不会向第三方出售或分享你的个人信息。
                你可以随时联系我们删除相关记录。
              </p>
            </div>
          </div>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/"
              className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              返回首页
            </Link>
            <Link
              to="/search"
              className="rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-accent-300 hover:text-accent-600 whitespace-nowrap"
            >
              去搜索内容
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}